import { IdeogramCjkVariantIcon } from './IdeogramCjkVariantIcon';

/**
 * author: Haley Halcyon
 * id 1D315F53-EBD0-42C7-89D6-5E682B756B22
 * name ideogram-cjk-variant
 * version: 4.9.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/ideogram-cjk-variant.svg
 * tags
 * - Alpha / Numeric 
 */
export const IdeogramChineseJapaneseKoreanVariantIcon = IdeogramCjkVariantIcon;
export default IdeogramChineseJapaneseKoreanVariantIcon